import React from 'react'
import styles from './A23PlayerBet.module.css';
import { CALL_ACTION, CHECK_ACTION, FOLD_ACTION, GAME_STAGE_SHOWDOWN, RAISE_ACTION, RUPEE_SYMBOL } from '@/Poker/data/Constants';
import gameAssets from '@themed-assets';
import { motion } from 'motion/react';
import { parseDecimalValuesOfNumber } from '../../../../Common/utils/GameUtils';

const initialAnimation = {
    scale: 0,
}

const animateAnimation = {
    scale: 1,
}

export default function A23PlayerBet({ lastAction, clientChairIndex, maxPlayers = 6, betAmount, isWinnerDeclared, gameStage }) {
    //console.log('Spruha log >>> last action >>> ', lastAction);
    const getPositionClass = () => {
        // Specific logic for 6 players
        // if (maxPlayers === 6) {
        //     if (clientChairIndex === 0) return styles.bottom;
        //     if (clientChairIndex === 1 || clientChairIndex === 2) return styles.left;
        //     if (clientChairIndex === 3) return styles.top;
        //     if (clientChairIndex === 4 || clientChairIndex === 5) return styles.right;
        // }

        // // Specific logic for 2 players
        // if (maxPlayers === 2) {
        //     if (clientChairIndex === 0) return styles.bottom;
        //     if (clientChairIndex === 1) return styles.top;
        // }

        // // Specific logic for 4 players
        // if (maxPlayers === 4) {
        //     if (clientChairIndex === 0) return styles.bottom;
        //     if (clientChairIndex === 1) return styles.left;
        //     if (clientChairIndex === 2) return styles.top;
        //     if (clientChairIndex === 3) return styles.right;
        // }

        // Generic logic for other player counts
        const halfPoint = Math.floor(maxPlayers / 2);
        if (clientChairIndex === 0) return styles.bottom;
        if (clientChairIndex < halfPoint) return styles.left;
        if (clientChairIndex === halfPoint) return styles.top;
        return styles.right;
    };

    // We want to persist the Fold last action throughout the game for more info on the game table.
    if ((isWinnerDeclared || gameStage === GAME_STAGE_SHOWDOWN) && lastAction !== FOLD_ACTION) {
        return null;
    }

    if (lastAction === CHECK_ACTION || lastAction === FOLD_ACTION) {
        return;
        // return (
        //     <div className={`${styles.playerLastActionContainer} ${getPositionClass()}`}>
        //         <motion.div
        //             initial={initialAnimation}
        //             animate={animateAnimation}
        //             className={styles.playerLastAction}>
        //             <div className={styles.playerLastActionIcon}>
        //                 <img src={lastAction === CHECK_ACTION ? gameAssets.check : gameAssets.fold} alt="Red Chip" />
        //             </div>
        //             <div className={styles.playerLastActionText}>
        //                 {lastAction}
        //             </div>
        //         </motion.div>
        //     </div>
        // );
    }

    return betAmount ? (
        <div className={`${styles.playerLastActionContainer} ${getPositionClass()}`}>
            <motion.div
                initial={initialAnimation}
                animate={animateAnimation}
                className={styles.playerLastAction}
            >
                <div className={styles.playerLastActionIcon}>
                    <img src={gameAssets.brandChip2} alt="Red Chip" />
                </div>
                <div className={styles.playerLastActionAmount}>
                    {/* {lastAction === CALL_ACTION ? 'Call' : lastAction === RAISE_ACTION ? 'Bet' : null} */}
                    {RUPEE_SYMBOL}{parseDecimalValuesOfNumber(betAmount, 2)}
                </div>
            </motion.div>
        </div>
    ) : null;
}
